import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserPostsDataService } from '../../../services/posts.service';

import { ReplySubmitModalComponent } from '../../../modals/reply-submit-modal/reply-submit-modal.component';
import { QuoteModalComponent } from '../../../modals/quote-modal/quote-modal.component';
import { ScoreModalComponent } from '../../../modals/score-modal/score-modal.component';

@Component({
    selector: 'app-reactions',
    templateUrl: './reactions.component.html',
    styleUrls: ['./reactions.component.css']
})
export class ReactionsComponent {
    @Input() postData: any;
    @Input() UserID: number;

    @Output() reactionsUpdated = new EventEmitter<any>();
    @Output() postEditedOrDeleted: EventEmitter<void> = new EventEmitter<void>();

    @Output() mediaUrlsChange = new EventEmitter<any[]>();
    @Output() replyTypeChange = new EventEmitter<any>();
    @Output() postContent = new EventEmitter<any>();
    @Output() onSave = new EventEmitter<number>();      

    isDropdownOpen = false;

    /** Local UI toggle for bookmark (no API yet; matches Lovable filled state). */
    bookmarkToggled = false;

    selectedReplyType: number = 1;

    constructor(
        private userPostsDataService: UserPostsDataService,
        private modalService: NgbModal
    ) { }

    openReplySubmitModal(originalPostID: number, replyPostID: number, postUsername: string ): void {
        const modalRef = this.modalService.open(ReplySubmitModalComponent, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg'
        });

        // Pass values to modal instance
        modalRef.componentInstance.OriginalPostID = originalPostID;
        modalRef.componentInstance.ReplyPostID = replyPostID;
        modalRef.componentInstance.PostUsername = postUsername;

        modalRef.componentInstance.postEditedOrDeleted.subscribe(() => {
            this.reactionsUpdated.emit();  // Pass event up to Dashboard
        });
    }



    toggleReaction(postId: number, type: '1' | '2' | '3'): void {
        this.userPostsDataService.toggleReaction(postId, this.UserID, type).subscribe(updatedReactions => {
            this.postData.Reactions = updatedReactions;
            this.reactionsUpdated.emit(updatedReactions);
        }, error => {
            console.error('Error toggling reaction:', error);
        });
    }

    //saveRePost(postId: number, originalPostId: number, type: '1' | '2' | '3', repostSelected: boolean, repostType: string, comment: string): void {
    saveRePost(postId: number, originalPostId: number, type: '1' | '2' | '3', repostSelected: boolean, repostType: string, comment: string): void {
        this.userPostsDataService.saveUserRePostsData(postId, originalPostId, this.UserID, type, this.selectedReplyType, comment, repostSelected).subscribe(updatedReactions => {
            //  postId: number, originalPostId: number, userId: number, reactionType: string, postContent: string, active: boolean
            this.postData.Reactions = updatedReactions;
            //this.reactionsUpdated.emit(updatedReactions);
            this.reactionsUpdated.emit();
            this.postEditedOrDeleted.emit();
            this.isDropdownOpen = false; // Close the dropdown menu
        }, error => {
            console.error('Error saving repost:', error);
        });
    }

    openQuoteModal(postData: any): void {
        const modalRef = this.modalService.open(QuoteModalComponent, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg'
        });

        modalRef.componentInstance.postData = postData;

        //modalRef.componentInstance.replyTypeChange.subscribe((type: any) => {
        //    this.selectedReplyType = type.id;
        //});

        //modalRef.componentInstance.postQuote.subscribe((comment: string) => {
        //    if (comment.length > 0) {
        //        this.saveRePost(postData.TSID, postData.OriginalPostID, '2', postData.Reactions.repostSelected, '2', comment);
        //    } else {
        //        this.saveRePost(postData.TSID, postData.OriginalPostID, '2', postData.Reactions.repostSelected, '1', null);
        //    }
        //});

        //modalRef.componentInstance.mediaUrlsChangeModal.subscribe((media: any[]) => {
        //    this.mediaUrlsChange.emit(media);  // Pass event up to Dashboard
        //});

        //modalRef.componentInstance.replyTypeChange.subscribe((type: any) => {
        //    this.replyTypeChange.emit(type);  // Pass event up to Dashboard
        //});

        //modalRef.componentInstance.postContent.subscribe((postContent: any) => {
        //    this.postContent.emit(postContent);  // Pass event up to Dashboard
        //});

        //modalRef.componentInstance.onSave.subscribe(() => {
        //    this.onSave.emit(5);
        //});

        modalRef.componentInstance.postEditedOrDeleted.subscribe(() => {
            this.reactionsUpdated.emit();  // Pass event up to Dashboard
        });

    }

    openScoreModal(postData: any): void {
        const modalRef = this.modalService.open(ScoreModalComponent, {
            keyboard: false,
            backdrop: 'static',
            size: 'lg'
        });

        modalRef.componentInstance.postData = postData;
    }

    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    toggleBookmarkUi(event: MouseEvent): void {
        event.stopPropagation();
        this.bookmarkToggled = !this.bookmarkToggled;
    }

    onShareClick(event: MouseEvent): void {
        event.stopPropagation();
        if (typeof navigator !== 'undefined' && navigator.clipboard && typeof window !== 'undefined') {
            const url = window.location.origin + '/' + (this.postData?.UserName || '') + '/posts/' + (this.postData?.TSID || '');
            navigator.clipboard.writeText(url).catch(() => { /* ignore */ });
        }
    }
}
